module.exports = __webpack_public_path__ + "img/do.b384800c.svg";